import React from "react";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_labor-legal-studio/artifacts/9xdsrj2x__ROC2981%20%281%29.jpg";

export default function About() {
    return (
        <section
            id="studio"
            data-testid="about-section"
            className="py-24 lg:py-36 bg-[#FAFAFA]"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex items-center gap-4 mb-6">
                    <span className="gold-rule" />
                    <span className="label-eyebrow">Lo Studio</span>
                </div>

                <h2 className="font-serif text-navy text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-14 max-w-4xl">
                    Un avvocato al fianco di
                    <span className="italic text-gold-deep"> chi lavora</span>,
                    con il rigore di chi conosce l'impresa.
                </h2>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    {/* Text column */}
                    <div className="lg:col-span-7 order-2 lg:order-1 space-y-7 text-slate-700 text-base md:text-lg leading-relaxed">
                        <p>
                            Lo Studio ha sede a <strong className="text-navy">Piacenza, Milano e Lecce</strong>, opera in tutta Italia e riceve, in base alle diverse esigenze, anche in modalità remota. È specializzato in <strong className="text-navy">diritto del lavoro</strong> e offre consulenza, assistenza giudiziale e stragiudiziale a lavoratori, dirigenti e aziende.
                        </p>
                        <p>
                            È uno <strong className="text-navy">Studio boutique</strong>, che vanta una profonda esperienza in tema di conciliazione stragiudiziale tra Datore e Lavoratore e sulla assistenza continuativa alle Aziende, in <strong className="text-navy">outsourcing</strong>, in ogni ambito del diritto del lavoro e d'impresa.
                        </p>
                        <p>
                            L'attività si caratterizza per un approccio <em className="text-navy">analitico e sartoriale</em>: ogni caso viene analizzato nel dettaglio, con riservatezza e nella prospettiva di trovare la soluzione più efficace, sempre nell'esclusivo interesse del cliente.
                        </p>
                    </div>

                    {/* Portrait column */}
                    <div className="lg:col-span-5 order-1 lg:order-2 relative lg:pl-6" data-testid="about-portrait-wrap">
                        <div className="relative max-w-md mx-auto lg:max-w-none lg:ml-auto">
                            <div className="absolute -top-4 -right-4 w-full h-full border border-gold pointer-events-none hidden md:block" aria-hidden="true" />
                            <img
                                src={PORTRAIT}
                                alt="Avv. Marco Candido — Studio Legale Diritto del Lavoro"
                                data-testid="lawyer-portrait"
                                loading="lazy"
                                className="relative w-full aspect-[4/5] object-cover object-top grayscale-[10%]"
                            />
                            <div className="absolute -bottom-5 -left-5 bg-navy text-white px-5 py-4 max-w-[260px] hidden md:block">
                                <div className="font-serif text-base text-gold leading-tight">Avv. Marco Candido</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
